import { Box, CircularProgress, Typography } from "@mui/material";
import styles from "../../Styles/registerContainer.module.css";

type LoadingProps = {
  message?: string;
};
export default function Loading(props: LoadingProps) {
  const { message } = props;
  return (
    <div id="loading" className={styles.loading}>
      <Box display="flex" flexDirection="column" alignItems="center">
        <CircularProgress color="primary" size={80}  style={{ marginBottom: '10px' }}/>
        <Typography variant="h6" color="white"  fontSize={35} style={{ marginBottom: '180px' }}>
          {message}
        </Typography>
      </Box>
    </div>
  );
}
